import React from 'react'
import { SearchDropdown, HighlightedText } from '@ui'
import { UseSpaceTypesHook } from './hooks/useSpaceTypes'
import { NavigateFn } from '@reach/router'
import useSpaceTypeSearch from './hooks/useSpaceTypesSearch'
import track from '@track'

export default function SpaceTypeSearch({
  hook,
  navigate,
}: {
  hook: UseSpaceTypesHook
  navigate?: NavigateFn
}) {
  const { run, items, query, loading } = useSpaceTypeSearch()
  return (
    <SearchDropdown
      width={'300px'}
      search={{ run, items, query, loading }}
      onSelect={(spaceType) => {
        hook.search(spaceType.displayName)
        track.spaceTypes({
          eventName: track.Event.SEARCH_RESULT_CLICK,
        })
      }}
      renderItem={(spaceType) => <HighlightedText text={spaceType.displayName} query={query} />}
      queryTable={(string) => hook.search(string)}
    />
  )
}
